import uuid from 'uuid/v4'

export function timesHash(times) {
  const hash = {}
  times.forEach(t => {
    const key = t.id ? t.id : uuid()
    hash[key] = t
  })
  return hash
}
